(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aurrelle-research-citations"] && !Shopify.designMode) return;
  try {
    
  const initialiseAurrelleScience = (root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const slides = Array.from(root.querySelectorAll('[data-aur-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-aur-dot]'));
    const previous = root.querySelector('[data-aur-previous]');
    const next = root.querySelector('[data-aur-next]');
    if (slides.length < 2) {
      if (previous) previous.hidden = true;
      if (next) next.hidden = true;
      return;
    }

    let active = 0;
    let timer;
    const autoplay = root.dataset.autoplay === 'true';
    const interval = Math.max(Number(root.dataset.interval) || 7000, 4000);

    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const selected = slideIndex === active;
        slide.hidden = !selected;
        slide.classList.toggle('is-active', selected);
      });
      dots.forEach((dot, dotIndex) => {
        const selected = dotIndex === active;
        dot.classList.toggle('is-active', selected);
        dot.setAttribute('aria-pressed', String(selected));
      });
    };

    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(() => show(active + 1), interval);
      }
    };

    previous.addEventListener('click', () => {
      show(active - 1);
      start();
    });
    next.addEventListener('click', () => {
      show(active + 1);
      start();
    });
    dots.forEach((dot) => dot.addEventListener('click', () => {
      show(Number(dot.dataset.aurDot));
      start();
    }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    start();
  };

  document.querySelectorAll('[data-aur-science]').forEach(initialiseAurrelleScience);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-aur-science]').forEach(initialiseAurrelleScience);
  });

  } catch(e) { console.error(e); }
})();
})();
